import React from "react";
import { motion } from "framer-motion";

const steps = [
  {
    title: "Business Account Registration",
    description:
      "Create your dedicated business account to begin the onboarding process.",
    icon: "bi-person-plus",
  },
  {
    title: "Content Submission",
    description:
      "Share your brand details, images, and content to personalize your website.",
    icon: "bi-file-earmark-text",
  },
  {
    title: "Template Selection",
    description:
      "Choose a website template that best represents your business identity.",
    icon: "bi-layout-text-window-reverse",
  },
  {
    title: "Domain Selection & Booking",
    description:
      "Pick an available domain name and we will complete the booking for you.",
    icon: "bi-globe2",
  },
  {
    title: "Payment Completion",
    description:
      "Secure your website setup with a quick and seamless payment process.",
    icon: "bi-credit-card",
  },
  {
    title: "Website Launch",
    description:
      "Your website goes live! We configure hosting and deployment for you.",
    icon: "bi-rocket-takeoff",
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15,
      duration: 0.5,
      type: "spring",
    },
  }),
};

export default function WebsiteProgressSteps() {
  return (
    <div className="container py-5">
      <h4 className="text-center mb-4 fw-bold">
        Your Website Completion Stages
      </h4>
      <div className="row g-4">
        {steps.map((step, index) => (
          <motion.div
            key={index}
            className="col-md-4"
            custom={index}
            initial="hidden"
            animate="visible"
            variants={cardVariants}
          >
            <div
              className="card shadow-sm border-0 h-100 text-center p-4 rounded-4"
              style={{ alignItems: "center" }}
            >
              <div
                className="rounded-circle bg-primary text-white d-inline-flex align-items-center justify-content-center mb-3"
                style={{ width: "70px", height: "70px", fontSize: "28px" }}
              >
                <i className={`bi ${step.icon}`}></i>
              </div>

              <h5 className="fw-bold">{step.title}</h5>
              <p className="text-muted">{step.description}</p>

              {/* Animated underline */}
              <motion.div
                className="mt-2 mx-auto"
                style={{
                  height: "3px",
                  width: "40px",
                  background: "#0d6efd",
                  borderRadius: "5px",
                }}
                initial={{ width: 0 }}
                animate={{ width: 40 }}
                transition={{ duration: 0.5, delay: index * 0.15 }}
              />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
